export const firebaseConfig = {
  apiKey: 'AIzaSyBsCors8Be_rp-smzyk6tp12uCeWh_7dw8',
  authDomain: 'aspectprospectmap.firebaseapp.com',
  databaseURL: 'https://aspectprospectmap.firebaseio.com',
  projectId: 'aspectprospectmap',
  storageBucket: 'aspectprospectmap.appspot.com',
  messagingSenderId: '824371876066',
};

const sentryAPI = 'b34f858bcc8c4fe480799294c725994a';
const sentryProjectId = '260254';
export const sentryUrl = `https://${sentryAPI}@sentry.io/${sentryProjectId}`;



// WEBPACK FOOTER //
// ./src/data/config.js